import React from 'react';
import styled, { keyframes } from 'styled-components';
import { eventos } from '../-EVENTOS/-Eventos'; // Ajusta la ruta


const Noticia = ({ noticia }) => {
  return (
    <NoticiaStyled>
      <NoticiaTitulo>{noticia.titulo}</NoticiaTitulo>
      {/* <NoticiaFecha>Fecha: {fechaFormateada}</NoticiaFecha> */}
      {noticia.contenido.split('.').map((item, index) => (
        <NoticiaContenido key={index}>{item.trim()}</NoticiaContenido>
      ))}
      {noticia.enlaces.map((enlace, index) => (
        <VerMasBoton key={index} href={enlace.url} target="_blank">{enlace.texto}</VerMasBoton>
      ))}
    </NoticiaStyled>
  );
};





const NoticiaPrincipal = () => {
  // Noticias generadas automáticamente desde eventos con inscripción
  const hoy = new Date();

  const noticiasDeEventos = eventos
    .filter(evento => {
      // Verificamos si tiene URL de inscripción
      if (!evento.urlInscripcion || evento.urlInscripcion.trim() === '') return false;
  
      // Tomamos la última fecha del rango (si hay guión), o la única fecha
      const fechaTexto = evento.fecha.includes('-')
        ? evento.fecha.split('-')[1].trim()  // última fecha del rango
        : evento.fecha.trim();
  
      const [dia, mes, anio] = fechaTexto.split('/');
      const fechaFinEvento = new Date(anio, mes - 1, dia);
  
      // Solo incluimos eventos cuyo fin es hoy o en el futuro
      return fechaFinEvento >= hoy;
    })
    .map(evento => ({
      id: evento.id,
      titulo: `¡Inscripción ${evento.nombre}!`,
      fecha: evento.fecha,
      contenido: '',
      enlaces: [
        { texto: "Inscripción", url: evento.urlInscripcion }
      ]
    }));
  // Noticias escritas manualmente
  const noticiasEstaticas = [

 
   {
      id: 16,
      titulo: 'Información e inscripción Intensivo NSTA&RG',
      fecha: '30/06/2025 ',
      contenido: '',
      enlaces: [
        { texto: "Mas información e inscripción  ", url: 'https://netsportacademy.com/clubs/riogrande/intensivosdeverano' },

      ]
    },


    {
      id: 15,
      titulo: 'Inscripción al intensivo de tenis NSTA & CLUB RIO GRANDE 2025',
      fecha: '30/06/2025 ',
      contenido: '',
      enlaces: [
        { texto: "Inscripción  ", url: 'https://docs.google.com/forms/d/1sGiFQ90Hn5V8UxU-yryt7p2h-BebTzUgnKG1YP8Rb2I/viewform?edit_requested=true' },

      ]
    },




    


    // {
    //   id: 14,
    //   titulo: '¡Inscripción e información general Torneo Otoño Rio Grande!',
    //   fecha: '30/11/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/eventos/torneo-otoo-rio-grande' },

    //   ]
    // },




    // {
    //   id: 1,
    //   titulo: 'Explora los Próximos Eventos!',
    //   fecha: '16/04/2024',
    //   contenido: '¡No te pierdas nuestra emocionante agenda de eventos en Net Sport Events! Tenemos actividades para todos los entusiastas del deporte. Consulta todos los eventos y asegúrate de reservar tu lugar.',
    //   enlaces: [{ texto: "Ver más", url: 'https://netsportacademy.com/eventos' }]
    // },

    // {
    //   id: 2,
    //   titulo: 'Última noticia!',
    //   fecha: '17/04/2024',
    //   contenido: 'Hoy es miércoles festivo en Sevilla, por lo tanto, no habrá escuela en el Club Río Grande. Consulta nuestro calendario para más detalles.',
    //   enlaces: [{ texto: "Ver más", url: 'https://netsportacademy.com/clubs/riogrande/calendarioriogrande' }]
    // },


    // {
    //   id: 3,
    //   titulo: '¡Abierto el plazo de inscripción del campus de verano de Club Airbus! ',
    //   fecha: '24/04/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "⁠Campus de Verano en Club Airbus", url: 'https://netsportacademy.com/clubs/airbus/campusdeverano' },


    //   ]
    // },
    // {
    //   id: 4,
    //   titulo: '¡Abierto el plazo de inscripción del campus de verano e intensivo de tenis de Bellavista Huelva Club!',
    //   fecha: '25/04/2024',
    //   contenido: '',
    //   enlaces: [

    //     { texto: "⁠Campus de Verano en Bellavista Huelva Club ", url: 'https://netsportacademy.com/clubs/bellavista/campusdeverano' },
    //     { texto: "Intensivos en Bellavista Huelva Club", url: 'https://netsportacademy.com/clubs/bellavista/intensivosdeverano' }
    //   ]
    // },





    // {
    //   id: 6,
    //   titulo: '¡Abierto el plazo de inscripción para el intensivo de tenis en el Club Río Grande!',
    //   fecha: '27/04/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Intensivos en Club Río Grande", url: 'https://netsportacademy.com/clubs/riogrande/intensivosdeverano' },

    //   ]
    // },




    // {
    //   id: 7,
    //   titulo: '¡Inscripción e información general temporada 24 - 25 Bellavista Huelva Club!',
    //   fecha: '10/08/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/clubs/bellavista/informacioneinscripcionbhc' },

    //   ]
    // },


    // {
    //   id: 8,
    //   titulo: '¡Inscripción e información general temporada 24 - 25 Club Rio Grande!',
    //   fecha: '12/08/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/clubs/riogrande/informacioneinscripcionrg' },

    //   ]
    // },


    // {
    //   id: 9,
    //   titulo: '¡Inscripción Spartan Tenis Tour 2024!',
    //   fecha: '8/08/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/eventos/spartan2024' },

    //   ]
    // },

    // {
    //   id: 10,
    //   titulo: '¡Inscripción Spartan Adultos Tenis Tour 2024!',
    //   fecha: '8/08/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/eventos/spartanabsoluto2024' },

    //   ]
    // },


    // {
    //   id: 11,
    //   titulo: '¡Inscripción e información general Torneo Social Club Rio Grande 2024!',
    //   fecha: '15/08/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/eventos/TorneoSocialRioGrande' },

    //   ]
    // },


    // {
    //   id: 12,
    //   titulo: '¡Inscripción e información general Torneo NSTA Series 1.0 Bellavista Huelva Club!',
    //   fecha: '17/9/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Información general", url: 'https://netsportacademy.com/eventos/TorneoNstaSeries1.0' },

    //   ]
    // },

    // {
    //   id: 13,
    //   titulo: '¡IMPORTANTE! Licencia Federativa Rio Grande 2024-25',
    //   fecha: '15/10/2024',
    //   contenido: '',
    //   enlaces: [
    //     { texto: "Ir a la vista", url: 'https://netsportacademy.com/clubs/riogrande/calendariodecompeticion' },

    //   ]
    // },



  ];

  // Combinar y ordenar todas las noticias
  const todasLasNoticias = [...noticiasDeEventos, ...noticiasEstaticas];

  todasLasNoticias.sort((a, b) => {
    const fechaA = new Date(a.fecha.split('/')[2], a.fecha.split('/')[1] - 1, a.fecha.split('/')[0]);
    const fechaB = new Date(b.fecha.split('/')[2], b.fecha.split('/')[1] - 1, b.fecha.split('/')[0]);
    return fechaB - fechaA;
  });

  return (
    <NoticiasContainer>
      {todasLasNoticias.map(noticia => (
        <Noticia key={`${noticia.id}-${noticia.fecha}`} noticia={noticia} />
      ))}
    </NoticiasContainer>
  );
};

export default NoticiaPrincipal;







const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

// Estilos
const NoticiasContainer = styled.div`
  animation: ${fadeIn} 2s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 15px;
  padding-top: 20px;
  height: 100vh;
  @media (max-width: 768px) {
    padding-top: 0px;
  }
`;

const NoticiaStyled = styled.div`
  font-family: 'Lumier', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  background-color: #ffffff;
  margin: 20px;
  padding: 10px;
  width: 80%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const NoticiaTitulo = styled.h2`
  font-weight: bold;
  color: #a0f000;
  margin-top: 10px;
  text-align: center;
  font-size: 33px;
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const NoticiaContenido = styled.p`
  font-family: 'RNSMiles';
  color: #3f3f3f;
  text-align: center;
  font-size: 17px;
  line-height: 1.2; 
  font-weight: bold; 
`;

const VerMasBoton = styled.a`
  background-color: #a0f000; 
  border: none;
  color: #000000;
  padding: 6px 14px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  margin: 10px;
  cursor: pointer;
`;
